"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var I18nContainer = function I18nContainer(_ref) {
  var locale = _ref.locale,
      messages = _ref.messages,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
    locale: locale,
    messages: messages,
    key: locale
  }, children);
};

I18nContainer.propTypes = {
  locale: _propTypes["default"].string,
  messages: _propTypes["default"].object,
  children: _propTypes["default"].object.isRequired
};
I18nContainer.defaultProps = {
  locale: undefined,
  messages: {}
};
var _default = I18nContainer;
exports["default"] = _default;